import { IconPlus } from '@tabler/icons-react';

export default function VariantesAnadirButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      aria-label="Agregar"
      className="text-white font-medium flex items-center justify-center shrink-0 w-8"
      style={{
        height: '32px',
        borderRadius: '9999px',
        backgroundColor: '#034EA2',
        border: 'none',
        cursor: 'pointer',
      }}
    >
      <IconPlus size={18} />
    </button>
  );
}